import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';

const USERS_API_BASE_URL = '/admin/users';
export const getModerationList = createAsyncThunk('user/moderate', async ({}, { rejectWithValue }) => {

	try {
		const response = await axiosConfig.post(`${USERS_API_BASE_URL}/moderate/list`, {}, {
			withCredentials: false
		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const uploadAvatar = createAsyncThunk('user/upload/avatar', async ({avatar = null}, { rejectWithValue }) => {

	try {

		if(avatar){
			let formData = new FormData();
			formData.append("avatar", avatar);
			const response = await axiosConfig.post(`${USERS_API_BASE_URL}/upload/avatar`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			return response.data;
		}
		return;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getUsersList = createAsyncThunk('user/list', async (_, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.get(`${USERS_API_BASE_URL}/list`);

		return response.data;

	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getAdminList = createAsyncThunk('user/admin/list', async (_, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.get(`${USERS_API_BASE_URL}/admins/list`);

		return response.data;

	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const sendRebrandAnnouncement = createAsyncThunk(
	'user/rebrand-announcement',
	async ({ audience, dryRun, testEmail, csvFile }, { rejectWithValue }) => {
		try {
			let response;

			if (csvFile) {
				const formData = new FormData();
				if (audience) {
					formData.append('audience', audience);
				}
				if (dryRun) {
					formData.append('dryRun', 'true');
				}
				if (testEmail) {
					formData.append('testEmail', testEmail);
				}
				formData.append('csv', csvFile);

				response = await axiosConfig.post(
					`${USERS_API_BASE_URL}/rebrand-announcement`,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					},
				);
			} else {
				response = await axiosConfig.post(
					`${USERS_API_BASE_URL}/rebrand-announcement`,
					{
						audience,
						...(dryRun !== undefined ? { dryRun } : {}),
						...(testEmail ? { testEmail } : {}),
					},
				);
			}

			return response.data;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);

export const createAdministrator = createAsyncThunk('user/create/admin', async ({ firstName, lastName, country, phone, timezone, password, avatar, email }, { rejectWithValue }) => {
	try {
		let formData = new FormData();

		formData.append("file", avatar[0]);
		formData.append("firstName", firstName);
		formData.append("lastName", lastName);
		formData.append("country", country);
		formData.append("email", email);
		if (phone != 0)
			formData.append("phone", phone);
		formData.append("timezone", timezone);
		if (password && password.trim() !== "")
			formData.append("password", password);

		const response = await axiosConfig.post(`${USERS_API_BASE_URL}/create/admin`, formData, {
			withCredentials: false,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});

		return response.data;

	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

